// extracted by mini-css-extract-plugin
module.exports = {"created-button":"created-button-1255466bc0928c98e48db203b453296a","errorMsg":"errorMsg-f605e0fb26806365c7d4d1917e0551e0"};